<template>
  <div class="page-content">
    <div class="activate-info">
      <Icon
        type="ios-checkmark-circle"
        color="#11CB64"
        size="60"
      />
      <div class="activate-result-text">
        激活成功
      </div>
      <div class="info-item">
        <span class="pay-info-label">激活服务：</span>
        <span>{{ detail.productName }}</span>
      </div>
      <div class="info-item">
        <span class="pay-info-label">服务到期日：</span>
        <span>{{ detail.serviceEnd }}</span>
      </div>
      <div class="info-item">
        <span class="pay-info-label">兑换时间：</span>
        <span>{{ detail.payTime }}</span>
      </div>
      <div class="footer-box">
        <Button
          v-if="detail.serviceUrl"
          type="primary"
          @click="goMyApp"
        >
          前往我的应用
        </Button>
      </div>
    </div>
  </div>
</template>
<script>


export default {
  components: {
  },
  data(){
    return {
      detail: {},
    };
  },
  computed: {

  },
  created(){
    // 获取产品详情
    this.getDetail();
  },
  methods: {
    // 获取产品详情
    getDetail(){
      const {orderNo} = this.$route.query;
      // const url = '/paycenter-charge/api/facade/order/payResult';
      const url ='/paycenter-charge/api/worktable/order/payResult';
      const params = {
        orderNo,
      };
      this.$http.get(url,params).then((res) => {
        if (res.success){
          this.detail = res.data;
        } else {
          this.$Message.warning(res.message||'获取产品详情失败');
        }
      });
    },
    // 我的应用
    goMyApp(){
      window.location.href = this.detail.serviceUrl;
      // this.$router.push({
      //   path: '/app/market/index',
      //   query: {
      //     appType: 'myApp',
      //   },
      // });
    },
  },
};
</script>
<style lang="less" scoped>
.page-content {
  background-color: #fff;
  padding: 100px 0;
}
.activate-info {
  text-align: center;
  .activate-result-text {
    font-size: 16px;
    font-weight: bold;
    padding: 10px 0;
  }
  .info-item {
    padding: 5px 0;
    color: #999;
    width: 240px;
    margin: 0 auto;
    text-align: left;
    white-space: nowrap;
    .pay-info-label {
      display: inline-block;
      width: 90px;
      text-align: right;
    }
  }
}
.footer-box {
  padding-top: 50px;
  text-align: center;
}
</style>
